/**
 * @copyright Copyright (c) 2015, Pacific Biosciences of California, Inc.
 * @author <a href="mailto:bskinner@pacificbiosciences.com">Brian Skinner</a>
 */

import {Facet} from "../facets/facet"
import {BARCODE_FRAME} from "../frames/barcode"
import { multisort, desc, valueToDate } from "../../core/utils/property-sort"

export const BARCODE_FACET = new Facet({
    frame: BARCODE_FRAME,
    defaultColumns:
        ["id", "name", "numRecords", "totalLength", "updatedAt", "createdAt"],
    initialSort: multisort(desc(valueToDate("updatedAt")), desc(valueToDate("createdAt"))),
    additionalColumns: [
        "uuid", "path",
        "tags", "projectId", "version", "md5", "createdBy", "comments", "barcodeType"],
    displayProperties: [
        "name", "updatedAt", "numRecords", "totalLength", "createdAt",
        "id", "uuid", "path",
        "tags", "projectId", "version", "md5", "createdBy", "comments", "barcodeType"]
})
